export default "__VITE_ASSET__DHBkEEyK__"